import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-plus': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8c136.9 0 248 111.1 248 248s-111.1 248-248 248-248-111.1-248-248 111.1-248 248-248zM177.3 380c71.3 0 118.8-50.4 118.8-121.2 0-7.1-0.6-13.9-1.9-20.7h-116.9v42.6h70.1c-5.2 34.2-37.5 53.3-70.1 53.3-43 0-77.2-35.5-77.2-78.1 0-42.6 34.3-78.1 77.2-78.1 18.1 0 36.2 6.2 49.4 19.1l33.6-32.6c-22.9-21.3-51.7-32.3-83-32.3-68.8 0-124 55.5-124 124s55.2 124 124 124zM407.5 273.8h35.2v-35.5h-35.2v-35.5h-35.5v35.5h-35.5v35.5h35.5v35.5h35.5v-35.5z'
      }
    ]
  }
})
